import http from '../httpService';

const AssociationRepresentativeService = {
  createAgreementService: params => http.post('association-representative/agreements', params),

  updateAgreementService: (agreementId, params) =>
    http.put(`association-representative/agreements/${agreementId}`, params),

  getAgreementByIdService: agreementId =>
    http.get(`association-representative/agreements/${agreementId}`),

  getPdfTemplateAgreementService: agreementId =>
    http.get(`association-representative/agreements/${agreementId}/pdf-template`),

  getAgreementDocxService: agreementId =>
    http.get(`association-representative/agreements/${agreementId}/docx-template`),

  uploadDeclarationOfComplianceService: (agreementId, params) =>
    http.post(
      `association-representative/agreements/${agreementId}/declaration-of-compliance`,
      params,
    ),

  getComplianceCertificatesService: agreementId =>
    http.get(`association-representative/agreements/${agreementId}/compliance-certificates`),

  uploadComplianceCertificatesService: (agreementId, params) =>
    http.post(
      `association-representative/agreements/${agreementId}/compliance-certificates`,
      params,
    ),

  getSignedAgreementService: agreementId =>
    http.get(`association-representative/agreements/${agreementId}/signed-agreement`),

  agreementsFulfilledService: agreementId =>
    http.get(`association-representative/agreements/fulfilled/${agreementId}`),

  setPaidInstallmentService: (installmentId, params) =>
    http.post(`association-representative/agreements/installments/paid/${installmentId}`, params),

  updateInstallmentService: (installmentId, params) =>
    http.put(`association-representative/agreements/installments/${installmentId}`, params),

  getInstallmentAttachUrlService: inquiryFileId =>
    http.get(`association-representative/agreements/installments/attachment/${inquiryFileId}`),

  createInstallmentAttachmentService: (installmentId, file) =>
    http.post(`association-representative/agreements/installments/attach/${installmentId}`, file),

  getFrequencySheetService: agreementId =>
    http.get(`association-representative/agreements/frequency-sheet/${agreementId}`),

  getAgreementEvolutionTermsService: agreementId =>
    http.get(`association-representative/agreements/${agreementId}/evolution-terms`),

  getInvestigatedService: params =>
    http.get('association-representative/inquiries/investigated', { params }),

  getInvestigatedByIdService: inquiryInvestigatedId =>
    http.get(`association-representative/inquiries/investigated/${inquiryInvestigatedId}`),

  getInquiryAttachmentsService: (inquiryId) =>
    http.get(`association-representative/inquiries/${inquiryId}/attachments`),

  createInquiryAttachmentService: (inquiryId, attachment) =>
    http.post(`association-representative/inquiries/${inquiryId}/attachments`, attachment),

  getInquiriesSummaryService: params =>
    http.get('association-representative/inquiries/summary', { params }),

  getInvestigatedRecordingsService: inquiryInvestigatedId =>
    http.get(
      `association-representative/inquiries/investigated/${inquiryInvestigatedId}/recordings`,
    ),

  getInvestigatedHistoryService: inquiryInvestigatedId =>
    http.get(`association-representative/inquiries/investigated/${inquiryInvestigatedId}/history`),

  getRelatedAssociationsService: associationId =>
    http.get(`association-representative/associations/related/${associationId}`),

  updateAgreementStatusService: (agreementId, params) =>
    http.post(`association-representative/agreements/${agreementId}/status`, params),

  forwardAgreementService: (agreementId, params) =>
    http.post(`association-representative/agreements/${agreementId}/forward`, params),

  cancelAgreementService: agreementId =>
    http.put(`association-representative/agreements/${agreementId}/cancel`),

  deleteFilesInquiryService: inquiryFileId => http.put(`association-representative/inquiries/${inquiryFileId}/delete`),

  getBoundDocumentsAttachments: inquiryId =>
    http.get(`association-representative/inquiries/${inquiryId}/bound-documents-attachments`),
};
export default AssociationRepresentativeService;
